enum ErrorTypeEnums {
    HARD_FATAL = 'hardFatal',
    EASY_FATAL = 'easyFatal',
    WARNING = 'warning',
    NOT_REACT = 'not_react',
}


export { ErrorTypeEnums };
